// extracted by mini-css-extract-plugin
export var iconPaper = "pageCompare-module--iconPaper--XQ8VC";
export var iconCircle = "pageCompare-module--iconCircle--ep6Me";
export var iconFace = "pageCompare-module--iconFace--CRUUp";
export var iconBoom = "pageCompare-module--iconBoom--qwij7";